var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.587 20.7456C49.2931 19.8366 48.4869 19.1909 47.533 19.105L34.5758 17.9284L29.4521 5.93608C29.0743 5.05719 28.2139 4.48828 27.258 4.48828C26.302 4.48828 25.4417 5.05719 25.0639 5.93813L19.9402 17.9284L6.98097 19.105C6.02879 19.193 5.22457 19.8366 4.92898 20.7456C4.6334 21.6546 4.90638 22.6517 5.62668 23.2802L15.4208 31.8697L12.5327 44.5916C12.3214 45.527 12.6845 46.4939 13.4606 47.0549C13.8778 47.3563 14.3659 47.5098 14.858 47.5098C15.2824 47.5098 15.7034 47.3954 16.0812 47.1693L27.258 40.4893L38.4307 47.1693C39.2483 47.6612 40.2789 47.6163 41.0533 47.0549C41.8298 46.4922 42.1925 45.5249 41.9812 44.5916L39.0931 31.8697L48.8872 23.2819C49.6076 22.6517 49.8826 21.6563 49.587 20.7456Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.6acebd2da508e4b7128762bfb1809578.svg";
export { ForwardRef as ReactComponent };